<template>
  <v-row class="px-5">
    <template v-for="header in headers">
      <v-col
        v-if="formModel[header.value]!=undefined && formModel[header.value]!=null || header.value == 'judgementCode'"
        :key="header.value"
        cols="12"
        :md="header.size || 6"
        class="row py-2"
      >
        <v-col
          :md="header.disableSplit ? 12:3"
          class="title py-0"
        >
          {{ header.text }}
        </v-col>
        <v-col
          v-if="header.value=='judgementCode' "
          :md="header.disableSplit ? 12:9"
          :class="`value ${header.disableSplit?'py-2':'py-0'}`"
        >
          {{ judgementCode }}
        </v-col>

        <v-col
          v-else
          :md="header.disableSplit ? 12:9"
          :class="`value ${header.disableSplit?'py-2':'py-0'}`"
        >
          {{ header.formatter? header.formatter(formModel[header.value]):formModel[header.value] }}
        </v-col>
      </v-col>
    </template>
  </v-row>
</template>

<script>

export default {
  name: 'CaseInfo',
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    judgementCode: {
      type: String,
      required: true,
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.title {
  color: #727272;
  font: normal normal normal 16px/17px Almarai !important;
  font-size: 16px !important;
}

.value {
  color: var(--app-dark-primary-color);
  font: normal normal bold 16px/25px Almarai !important;
  font-size: 16px !important;
}
</style>
